export const driverTypography = {
	fontFamily: '"Palanquin", sans-serif',
	h1: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 700,
		fontSize: '38px',
		lineHeight: '57px',
	},
	h3: {
		fontFamily: '"Palanquin", sans-serif',
		fontStyle: 'normal',
		fontWeight: 700,
		fontSize: '24px',
		lineHeight: '24px',
	},
	desktopHero: {
		fontFamily: '"Palanquin", sans-serif',
		fontStyle: 'normal',
		fontWeight: 700,
		fontSize: '80px',
		lineHeight: '76px',
	},
	desktopTitle: {
		fontFamily: '"Palanquin", sans-serif',
		fontStyle: 'normal',
		fontWeight: 700,
		fontSize: '32px',
		lineHeight: '40px',
	},
	title: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 700,
		fontSize: '24px',
		lineHeight: '28px',
	},
	'h3-sb': {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '20px',
		lineHeight: '26px',
	},
	subtitle: {
		fontFamily: '"Poppins", sans-serif',
		fontSize: '16px',
		fontStyle: 'normal',
		fontWeight: 700,
		lineHeight: '20px',
	},
	bodyTitle: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 700,
		fontSize: '20px',
		lineHeight: '24px',
	},
	bodyTitleSmall: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 700,
		fontSize: '18px',
		lineHeight: '20px',
	},
	body1: {
		fontFamily: '"Palanquin", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '20px',
		lineHeight: '24px',
	},
	body2: {
		fontFamily: '"Palanquin", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '16px',
		lineHeight: '20px',
	},
	caption: {
		fontFamily: '"Palanquin", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '12px',
		lineHeight: '16px',
	},
};

export const passengerTypography = {
	fontFamily: '"Public Sans", sans-serif',
	desktopHero: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '32px',
		lineHeight: '48px',
	},
	desktopTitle: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '32px',
		lineHeight: '48px',
	},
	title: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '24px',
		lineHeight: '36px',
	},
	subtitle: {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '14px',
		lineHeight: '21px',
	},
	bodyTitle: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '20px',
		lineHeight: '26px',
	},
	bodyTitleSmall: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '20px',
		lineHeight: '26px',
	},
	body1: {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '16px',
		lineHeight: '24px',
	},
	body2: {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '14px',
		lineHeight: '21px',
	},
	caption: {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '12px',
		lineHeight: '18px',
	},
	h1: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '32px',
		lineHeight: '48px',
	},
	'h1-sb': {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '32px',
		lineHeight: '48px',
	},
	h2: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '24px',
		lineHeight: '36px',
	},
	'h2-sb': {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '24px',
		lineHeight: '36px',
	},
	h3: {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '20px',
		lineHeight: '26px',
	},
	'h3-sb': {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '20px',
		lineHeight: '26px',
	},
	'h4-sb': {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '18px',
		lineHeight: '27px',
	},
	'h5-sb': {
		fontFamily: '"Poppins", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '16px',
		lineHeight: '24px',
	},
	'b1-m': {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '16px',
		lineHeight: '24px',
	},
	'b1-sb': {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: '16px',
		lineHeight: '24px',
	},
	b1: {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '16px',
		lineHeight: '24px',
	},
	'b2-m': {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '14px',
		lineHeight: '21px',
	},
	b2: {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '14px',
		lineHeight: '21px',
	},
	'bu1-m': {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '15px',
		lineHeight: '22.5px',
	},
	l1: {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '12px',
		lineHeight: '18px',
	},
	'l1-m': {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '12px',
		lineHeight: '18px',
	},
	l2: {
		fontFamily: '"Public Sans", sans-serif',
		fontStyle: 'normal',
		fontWeight: 400,
		fontSize: '10px',
		lineHeight: '15px',
	},
};
